import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function PrivateRoute({ children }) {
  const { token, loading } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.profile);

if (!token) {
  return <Navigate to="/login" replace />;
}

// only show spinner if we have a token but still fetching user
if (loading && !user) {
  return (
    <div className="flex items-center justify-center h-screen space-x-3">
      <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}

if (!user) {
  return <Navigate to="/login" replace />;
}

return children;
}

export default PrivateRoute;
